import { ZfLink, ZfStack, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useWealthPlanningNavigate } from '../../hooks/useWealthPlanningNavigate';

interface IProps {
    message: string;
    showWealthOverviewLink?: boolean;
    showEventsLink?: boolean;
}

export const SettingBoxEmptyState: FunctionComponent<IProps> = ({ message, showWealthOverviewLink, showEventsLink }) => {
    const { t } = useTranslation();
    const { navigate, partnerUuid } = useWealthPlanningNavigate();

    const goToWealthOverview = () => navigate(`/${partnerUuid}/wealth`);
    const goToEvents = () => navigate(`/${partnerUuid}/events`);

    return (
        <ZfStack direction="column" spacing="small" style={{ padding: 'var(--padding-vertical-md) var(--padding-horizontal-sm)' }}>
            <ZfTypography variant="body-small" color="muted">
                {message}
            </ZfTypography>
            {showEventsLink ? (
                <ZfTypography variant="body-small" color="muted">
                    <Trans
                        i18nKey="settingsDrawerEmpty.eventsOrWealthOverviewLink"
                        components={{
                            eventsLink: <ZfLink alias="button" size="small" onClick={goToEvents} />,
                            wealthLink: <ZfLink alias="button" size="small" onClick={goToWealthOverview} />,
                        }}
                    />
                </ZfTypography>
            ) : showWealthOverviewLink ? (
                <ZfLink alias="button" size="small" onClick={goToWealthOverview}>
                    {t('settingsDrawerEmpty.wealthOverviewLink')}
                </ZfLink>
            ) : null}
        </ZfStack>
    );
};
